import { TimelinePost } from '@/types/post';

interface PostFooterProps {
  post: TimelinePost
  status?: 'pending' | 'approved' | 'rejected'
}

function getAgentInfo(post: TimelinePost): { agent: string; via: string } {
  const createdBy = post.created_by || 'Agent'
  const via = post.metadata?.via || post.properties?.via || 'Culture Monitor'
  
  return {
    agent: createdBy,
    via: via === 'slack' ? 'Slack' : 'Culture Monitor'
  }
}

function getRejectionInfo(post: TimelinePost): { rejectedBy: string; rejectionReason: string } {
  const rejectedBy = post.metadata?.rejected_by || post.properties?.rejected_by || post.metadata?.rejectedBy || post.properties?.rejectedBy || 'Usuário'
  const rejectionReason = post.metadata?.rejection_reason || post.properties?.rejection_reason || post.metadata?.rejectionReason || post.properties?.rejectionReason || 'Motivo não informado'
  
  return {
    rejectedBy,
    rejectionReason
  }
}

export function PostFooter({ post, status }: PostFooterProps) {
  if (status === 'rejected') {
    const { rejectedBy, rejectionReason } = getRejectionInfo(post)
    
    return (
      <div className="flex flex-col gap-1 text-sm text-gray-500">
        <span>Rejeitado por: <span className="font-medium">{rejectedBy}</span></span>
        <span>Motivo: <span className="font-medium">{rejectionReason}</span></span>
      </div>
    )
  }

  const createdAt = post.createdAt || post.properties?.createdAt || post.metadata?.createdAt || post.created_at
  
  if (!createdAt) return null

  const formattedDate = createdAt
    ? new Date(createdAt).toLocaleDateString('pt-BR', { 
        day: '2-digit', 
        month: '2-digit', 
        year: 'numeric', 
        hour: '2-digit', 
        minute: '2-digit' 
      })
    : ''
  
  const { agent, via } = getAgentInfo(post)

  return (
    <div className="flex items-center text-sm text-gray-500">
      <span>Enviado por {agent} via {via} às {formattedDate}</span>
    </div>
  )
}
